import { render, staticRenderFns } from "./navigation-wrapper.vue?vue&type=template&id=3a1c099a&scoped=true&"
import script from "./navigation-wrapper.ts?vue&type=script&lang=ts&"
export * from "./navigation-wrapper.ts?vue&type=script&lang=ts&"
import style0 from "./navigation-wrapper.scss?vue&type=style&index=0&id=3a1c099a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c099a",
  null
  
)

export default component.exports